import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';

const toValidationFailure = (message) => {
  return Promise.resolve(createRequestFailure({ message }));
};

export default toValidationFailure;
